module.exports = __webpack_public_path__ + "img/logo3.afc5e922.png";